module.exports = __webpack_public_path__ + "static/media/background-mobile-one.f2f3ed2e.png";